const initialState = {
  leftMargin: '65px'
};

export default function appReducer(state = initialState, action) {
  switch (action.type) {
    case 'APP_SET_LEFT_MARGIN':
      return {
        ...state,
        leftMargin: action.payload,
      };
    default:
      return state;
  }
}